/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * AMS permission codes with no legacy permission behind them. On an AMS token they are read off the bitmap; on a Cognito session the api derives them from the MP role (super_admin, survey_upload_manager).
 */
export enum NativeAccessCode {
    SUPER_ADMIN = 'super.admin',
    SUPER_SURVEY_UPLOAD_MANAGER = 'super.survey_upload_manager',
}
